module.exports = __webpack_public_path__ + "img/noimage.a3b84ccf.png";